<script>
import { Line, mixins } from 'vue-chartjs';
const { reactiveProp } = mixins;

export default {
  extends: Line,
  name: 'LineChart',
  mixins: [reactiveProp],
  props: ['options'],
  watch: {
    chartData: function () {
      this.renderChart(this.chartData, this.options);
      this.setLegend();
    }
  },
  mounted() {
    this.renderChart(this.chartData, this.options);
    this.setLegend();
  },

  methods: {
    setLegend: function () {
      const legend = this.generateLegend();
      this.$emit('sendLegend', legend);
    }
  }
};
</script>
